/* unplugin-vue-components disabled */import { render } from "./newsList.vue?vue&type=template&id=cca6a022&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=cca6a022&lang=less&scoped=true"
import "../../assets/css/news/news.less?vue&type=style&index=1&id=cca6a022&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca6a022"]])

export default __exports__